
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { ISigmaRing } from '@/interfaces/mlm';
import ProductPrice from '@/components/Main/Rings/ProductPrice.vue';
import ProductSelectSize from '@/components/Main/Rings/ProductSelectSize.vue';

@Component({
  components: {
    ProductPrice,
    ProductSelectSize
  },
})
export default class ProductList extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isSizeKit!: boolean;
  @Prop({ type: Array, default: () => [] }) readonly sigma_rings!: ISigmaRing[];

  selectedSizeId: number | null = null;
  selectedRingProduct: ISigmaRing | null = null;

  // Метод для извлечения размера из имени продукта
  extractSizeFromName(name: string): number {
    const match = name.match(/Size:\s*(\d+)/i);
    return match ? parseInt(match[1], 10) : 6; // По умолчанию размер 6
  }

  // Методы для вычисления диаметра и окружности в шаблоне
  calculateDiameter(size: number): number {
    return 16.5 + ((size - 6) * 0.9);
  }

  calculateCircumference(size: number): number {
    return 52 + ((size - 6) * 3);
  }

  selectRingProduct(product: ISigmaRing): void {
    this.selectedSizeId = product.id;
    this.selectedRingProduct = product;
    this.$emit('size-selected-id', product.id);
  }

  // Установка первого элемента по умолчанию
  mounted() {
    // При монтировании всегда сбрасываем состояние и устанавливаем дефолтное значение
    this.selectedSizeId = null;
    this.selectedRingProduct = null;
    this.setDefaultSelection();
  }

  // Watcher для обновления выбора при изменении sigma_rings
  @Watch('sigma_rings', { immediate: false, deep: true })
  onSigmaRingsChanged(newRings: ISigmaRing[], oldRings: ISigmaRing[]): void {
    // Если список был пуст и стал заполненным - устанавливаем дефолт
    const wasEmpty = !oldRings || oldRings.length === 0;
    const isNotEmpty = newRings && newRings.length > 0;
    
    if (wasEmpty && isNotEmpty) {
      // Первая загрузка данных - устанавливаем дефолт
      this.setDefaultSelection();
      return;
    }

    // Проверяем, существует ли выбранный продукт в новом списке
    if (this.selectedSizeId !== null) {
      const selectedProductExists = newRings.some(ring => ring.id === this.selectedSizeId);
      
      if (!selectedProductExists) {
        // Выбранного продукта больше нет - устанавливаем дефолт
        this.setDefaultSelection();
      } else {
        // Обновляем ссылку на объект продукта, если он существует
        const foundProduct = newRings.find(ring => ring.id === this.selectedSizeId);
        if (foundProduct) {
          this.selectedRingProduct = foundProduct;
        }
      }
    } else if (isNotEmpty) {
      // Если выбор не был сделан, но список заполнен - устанавливаем дефолт
      this.setDefaultSelection();
    }
  }

  private setDefaultSelection(): void {
    if (this.sigma_rings.length === 0) {
      return;
    }

    // Всегда устанавливаем первый элемент как дефолтный
    const firstProduct = this.sigma_rings[0];
    this.selectedSizeId = firstProduct.id;
    this.selectedRingProduct = firstProduct;
    this.$emit('size-selected-id', firstProduct.id);
  }

  // Публичный метод для сброса выбора на дефолтное значение
  public resetSelection(): void {
    if (this.sigma_rings.length === 0) {
      return;
    }

    // Принудительно сбрасываем на первый элемент
    const firstProduct = this.sigma_rings[0];
    this.selectedSizeId = firstProduct.id;
    this.selectedRingProduct = firstProduct;
    this.$emit('size-selected-id', firstProduct.id);
  }
}
